import { render, staticRenderFns } from "./ZapiGroups.vue?vue&type=template&id=df7941b4&"
import script from "./ZapiGroups.vue?vue&type=script&lang=js&"
export * from "./ZapiGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports